import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

import IRouterComponentProps from "../models/IRouterComponentProps";
import AppLayout from "../components/layouts/AppLayout";
import {
  downloadandChangeShippingAddressInvoiceUrl,
  downloadandInternationalAnnualInvoiceUrl,
  internationalPerforma,
  invoiceUsdUrlAnnual,
  performainternationalInvoice,
  performaInvoiceAPI,
  productInvoiceApi,
  profileUrl,
  sendInvoiceRequest,
  simpleAnnualPerforma,
} from "../common/config/app.endpoints";
import AuthService from "../components/auth/AuthService";
import Alert from "../common/elements/Alert";
import LoadingSpinner from "../common/elements/LoadingSpinner";
import ApiTimeout from "./ApiTimeout";
import { oAuth } from "../routes/basic/BasicAppRouter";
import { StyledModal } from "../common/materials/GenericStyleComponent";
import BlockUserModal from "../components/products/BlockUser/BlockUserModal";
import moment from "moment";
import TrakingProcess from "../components/products/invoice/TrakingProcess";
import CoreDataofInvoiceProductAuction from "../components/core-grid/grid-data/CoreDataofInvoiceProductAuction";
import InvoiceListAuctionProduct from "../components/products/invoice/InvoiceListAuctionProduct";
import CategoryCarousal from "../components/category-carousal/CategoryCorousel";
import { AppDispatch } from "../redux/store";
import { useDispatch } from "react-redux";
import { resetIsRequest, setIsRequest } from "../redux/slice/annual/commanAnnualSlice";
import { resetSelectedDate, setselectedDate } from "../redux/slice/commanPagination/commanPaginationSlice";

const StyledLayoutGrid = styled(Grid)`
  padding: 30px 80px;
  ${(props) => props.theme.breakpoints.between("xs", "md")} {
    padding: 27px 10px;
  }
  ${(props) => props.theme.breakpoints.between("md", "lg")} {
    padding: 10px 30px;
  }
`;

const StyledTextWrapper = styled(Grid)`
  width: 100%;
  text-align: center;
  font-size: 1.5em;
  padding: 1em;
  font-family: Calibre-Regular;
  color: ${(props) => props.theme.colors.base.grey};
`;

const SyledHeader = styled(Grid)`
  font-size: 0.8em;
  padding: 0.8em;
  color: ${(props) => props.theme.colors.base.red};

  ${(props) => props.theme.breakpoints.between("xs", "md")} {
    font-size: 0.5em;
    padding: 0.5em;
  }
`;

interface IProps extends IRouterComponentProps {
  t?: any;
}
let data: any = [];
let auctionIdForTrackingRecord: any;
let auctionId: any;
const ProductAuctionInvoice = (props: IProps) => {
  const [invoice, setInvoice] = useState([]);
  const [performaInvoice, setPerformaInvoice] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [shippingAddress, setShippingAddress] = useState([]);
  const [apiTimeout, setApiTimeout] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [totalElementsPerforma, setTotalElementsPerforma] = useState(0);
  const [isUpdatedData, setIsUpdatedData] = useState(false);
  const [userBlock, setUserBlock] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isShowJewelley, setShowJewelley] = useState(false);
  const [isShowTracking, setIsShowTracking] = useState(true);

  const dispatch: AppDispatch = useDispatch();

  const Auth = new AuthService();
  const { t } = props;
  let userCurrencyCode = localStorage.getItem("preferredCurrency");
  const isUserCurrencyCode = () => {
    return userCurrencyCode && userCurrencyCode === "JPY";
  };

  useEffect(() => {
    localStorage.removeItem("auctionUserId");
    localStorage.removeItem("userId");
    localStorage.removeItem("currentProductIdOfBidNow");
    localStorage.removeItem("currentJewelleryProductIdOfBidNow");
    localStorage.removeItem("currentPDItem");

    var joinedAuctions: any = localStorage.getItem("joinedAnnualAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);
    if (joinedAuctions !== null) {
      joinedAuctions.filter((items: any) => {
        if (true) {
          if (items.category === "Jewellery") {
            auctionId = items.perId;
          }
        } else {
          if (items.category === "Diamonds") {
            auctionId = items.perId;
          }
        }
      });
    }

    function getData() {
      setIsLoading(true);
      setOpenToast(false);
      data = {
        filters: {
          and: [
            {
              match: "exact",
              name: "category",
              value: "Diamonds",
            },
          ],
        },
        page: {
          start: 0,
          count: 20,
          sort: {
            orders: [
              {
                property: "lastModifiedDate",
                direction: "DESC",
              },
            ],
          },
        },
      };
      if (joinedAuctions !== null) {
        joinedAuctions.filter((items: any) => {
          if (items.category === "Diamonds") {
            auctionId = items.perId;
          }
        });
      }
      if (!oAuth()) {
        props.history.push("/");
      } else {
        getProfileData();
        localStorage.removeItem("filteredValues");
        setIsShowTracking(false);
      }
    }

    getData();
    getInvoiceList(data, auctionId);
    // if (isUserCurrencyCode()) {
    //   getInvoiceList(data, auctionId);
    // } else {
    //   getusdInvoiceList(data, auctionId);
    // }
    getPerformaInvoiceList(auctionId, "Diamonds");
    setIsShowTracking(false);
    return () => {
      setIsLoading(false);
      setInvoice([]);
      setIsShowTracking(true);
      dispatch(resetIsRequest());
    };
  }, []);

  const getUpdatedInvoiceList = (value: any, start: any, endRecords: any) => {
    if (value === true) {
      getList(start, endRecords);
    }
  };

  const getList = (start: string | number, end: number) => {
    if (startDate !== null && endDate !== null) {
      data = {
        filters: {
          and: [
            {
              match: "between",
              name: "lastModifiedDate",
              gte: moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
              lte: moment(endDate).add(1, "d").format("YYYY-MM-DDTHH:mm:ss"),
            },
            {
              match: "exact",
              name: "category",
              value: isShowJewelley === true ? "Jewellery" : "Diamonds",
            },
          ],
        },
        page: {
          start: start,
          count: end,
          sort: {
            orders: [
              {
                property: "lastModifiedDate",
                direction: "DESC",
              },
            ],
          },
        },
      };
    } else {
      data = {
        filters: {
          and: [
            {
              match: "exact",
              name: "category",
              value: isShowJewelley === true ? "Jewellery" : "Diamonds",
            },
          ],
        },
        page: {
          start: start,
          count: end,
          sort: {
            orders: [
              {
                property: "lastModifiedDate",
                direction: "DESC",
              },
            ],
          },
        },
      };
    }

    if (!oAuth()) {
      props.history.push("/");
    } else {
      // if (isUserCurrencyCode()) {
      //   getInvoiceList(data, auctionId);
      // } else {
      //   getusdInvoiceList(data, auctionId);
      // }
      getInvoiceList(data, auctionId);
      getPerformaInvoiceList(
        auctionId,
        isShowJewelley === true ? "Jewellery" : "Diamonds"
      );
      setIsShowTracking(false);
    }
  };
  const itemPerPage = (value: boolean, start: number, itemPerPage: number) => {
    if (value === true) {
      localStorage.setItem("itemsPerPage", JSON.stringify(itemPerPage));
      getUpdatedInvoiceList(value, start, itemPerPage)
    }
  };

  const onSelectDate = (startDate: any, endDate: any) => {
    if (startDate !== null && endDate !== null) {
      setStartDate(startDate);
      setEndDate(endDate);
      data = {
        filters: {
          and: [
            {
              match: "between",
              name: "lastModifiedDate",
              gte: moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
              lte: moment(endDate).add(1, "d").format("YYYY-MM-DDTHH:mm:ss"),
            },
          ],
        },
        page: {
          start: 0,
          count: 20,
          sort: {
            orders: [
              {
                property: "lastModifiedDate",
                direction: "DESC",
              },
            ],
          },
        },
      };
    } else if (startDate === null && endDate === null) {
      data = {
        page: {
          start: 0,
          count: 20,
          sort: {
            orders: [
              {
                property: "lastModifiedDate",
                direction: "DESC",
              },
            ],
          },
        },
      };
    }
    if (!oAuth()) {
      props.history.push("/");
    } else {
      if (startDate > endDate) {
        setAlertType("error");
        setOpenToast(true);
        setShowMessage("End date should be greater than start date");

        setTimeout(() => {
          setOpenToast(false);
        }, 2000);
      } else {
        // if (isUserCurrencyCode()) {
        //   getInvoiceList(data, auctionId);
        // } else {
        //   getusdInvoiceList(data, auctionId);
        // }
        getInvoiceList(data, auctionId);
        getPerformaInvoiceList(
          auctionId,
          isShowJewelley === true ? "Jewellery" : "Diamonds"
        );
        setIsShowTracking(false);
      }
    }
  };

  const getProfileData = () => {
    Auth.getRequest(profileUrl, (status: number, response: any) => {
      if (status === 200) {
        if (response !== undefined) {
          if (response.shippingAddresses !== undefined) {
            if (response.shippingAddresses !== null) {
              response.shippingAddresses.forEach((item: any, i: number) => {
                if (item.primary === true) {
                  response.shippingAddresses.splice(i, 1);
                  response.shippingAddresses.unshift(item);
                }
              });
              setShippingAddress(response.shippingAddresses);
            }
          }
        }
      } else if (status === 403) {
        setUserBlock(true);
      } else if (status === 505) {
        setApiTimeout(true);
      } else {
        setAlertType("error");
        setOpenToast(false);
        setShowMessage(response);
        setIsLoading(false);
      }
    });
  };

  const getInvoiceList = (data: any, id: any) => {
    setIsUpdatedData(true);
    const { t } = props;
    Auth.postRequest(
      `${productInvoiceApi}?auctionId=${id}`,
      data,
      (status: any, response: any) => {
        if (status === 200) {
          if (response !== undefined) {
            if (response.length !== 0) {
              setTotalElements(response?.totalElements);
              setInvoice(response?.results);
            } else {
              setInvoice([]);
            }
            setIsLoading(false);
            setIsUpdatedData(false);
          } else {
            setAlertType("error");
            setShowMessage(response);
            setOpenToast(true);
            setIsLoading(false);
            setIsUpdatedData(false);
          }
        } else if (status === 403) {
          setUserBlock(true);
        } else if (status === 404) {
          setAlertType("error");
          setShowMessage(`${t("common:invalidRequest")}`);
          setOpenToast(true);
          setIsLoading(false);
          setIsUpdatedData(false);
        } else if (status === 505) {
          setApiTimeout(true);
          setIsUpdatedData(false);
        } else {
          setAlertType("error");
          setShowMessage(response[0].message);
          setIsLoading(false);
          setOpenToast(false);
          setIsUpdatedData(false);
        }
      }
    );
  };

  const getusdInvoiceList = (data: any, id: string) => {
    setIsUpdatedData(true);
    const { t } = props;
    Auth.postRequest(
      `${invoiceUsdUrlAnnual}?auctionId=${id}`,
      data,
      (status: any, response: any) => {
        if (status === 200) {
          if (response !== undefined) {
            if (response.length !== 0) {
              setTotalElements(response.length);
              setInvoice(response);
            } else {
              setInvoice([]);
            }
            setIsLoading(false);
            setIsUpdatedData(false);
          } else {
            setAlertType("error");
            setShowMessage(response);
            setOpenToast(true);
            setIsLoading(false);
            setIsUpdatedData(false);
          }
        } else if (status === 403) {
          setUserBlock(true);
        } else if (status === 404) {
          setAlertType("error");
          setShowMessage(`${t("common:invalidRequest")}`);
          setOpenToast(true);
          setIsLoading(false);
          setIsUpdatedData(false);
        } else if (status === 505) {
          setApiTimeout(true);
          setIsUpdatedData(false);
        } else {
          setAlertType("error");
          setShowMessage(response[0].message);
          setIsLoading(false);
          setOpenToast(false);
          setIsUpdatedData(false);
        }
      }
    );
  };

  const getPerformaInvoiceList = (id: string, category: string) => {
    const { t } = props;

    let url = `${isUserCurrencyCode() ? performaInvoiceAPI : performainternationalInvoice
      }?auctionId=${id}&category=${category}`;
    Auth.getRequest(url, (status: any, response: any) => {
      if (status === 200) {
        if (response !== undefined) {
          if (response === "") {
            setPerformaInvoice([
              {
                id: "",
                auctionName: "365 Days Auction_Performa Invoice",
                auctionId: "",
                auctioneerName: "",
                amountPaidByBidder: 0,
                amountPaidBySeller: 0,
                lastModifiedDate: "",
                category: "",
                invoiceType: "PERFORMA",
                invoiceNumber: 0,
              },
            ]);
            setTotalElementsPerforma(1);
            let isRequestEmail = true;
            dispatch(setIsRequest({ isRequestEmail }));
          } else {
            setPerformaInvoice([response]);
            let isRequestEmail = response.requestInvoiceMailSent;
            setTotalElementsPerforma(1);
            dispatch(setIsRequest({ isRequestEmail }));
          }
          setIsLoading(false);
          setIsUpdatedData(false);
        } else {
          setAlertType("error");
          setShowMessage(response);
          setOpenToast(true);
          setIsLoading(false);
          setIsUpdatedData(false);
        }
      } else if (status === 403) {
        setUserBlock(true);
      } else if (status === 404) {
        setAlertType("error");
        setShowMessage(`${t("common:invalidRequest")}`);
        setOpenToast(true);
        setIsLoading(false);
        setIsUpdatedData(false);
      } else if (status === 505) {
        setApiTimeout(true);
        setIsUpdatedData(false);
      } else {
        setAlertType("error");
        setShowMessage(response[0].message);
        setIsLoading(false);
        setOpenToast(false);
        setIsUpdatedData(false);
      }
    });
  };

  const sendMessage = (message: string) => {
    setShowMessage(message);
    setOpenToast(false);
    setAlertType("success");
    setOpenToast(true);
    setIsLoading(false);
  };

  const timeout = (timeout: boolean) => {
    if (timeout === true) {
      setApiTimeout(true);
    }
  };

  const closeModal = () => {
    Auth.logout();
    props.history.replace("/");
  };

  const forDownloadInvoice = (
    id: string,
    auctionName: string,
    onClickDownloadButton: boolean
  ) => {
    setIsUpdatedData(true);
    const Auth = new AuthService();
    if (onClickDownloadButton === true) {
      Auth.getRequestForDownload(
        `${downloadandChangeShippingAddressInvoiceUrl}/${id}/download_invoice`,
        (status: any, response: any) => {
          if (status === 200) {
            if (response !== undefined) {
              const url = window.URL.createObjectURL(new Blob([response]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `${auctionName}.pdf`);
              document.body.appendChild(link);
              link.click();
            }
            setIsUpdatedData(false);
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setIsUpdatedData(false);
          } else {
            setAlertType("error");
            setShowMessage(response);
            setOpenToast(false);
            setIsUpdatedData(false);
          }
        }
      );
    }
  };

  const internationalInvoice = (
    invoiceId: string,
    auctionName: string,
    onClickDownloadButton: boolean
  ) => {
    setIsUpdatedData(true);
    const Auth = new AuthService();
    if (onClickDownloadButton === true) {
      Auth.getRequestForDownload(
        `${downloadandInternationalAnnualInvoiceUrl}${invoiceId}`,
        (status: any, response: any) => {
          if (status === 200) {
            if (response !== undefined) {
              const url = window.URL.createObjectURL(new Blob([response]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `${auctionName}.pdf`);
              document.body.appendChild(link);
              link.click();
            }
            setIsUpdatedData(false);
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setIsUpdatedData(false);
          } else {
            setAlertType("error");
            setShowMessage(response);
            setOpenToast(false);
            setIsUpdatedData(false);
          }
        }
      );
    }
  };

  const downloadInternationalPerformaInvoice = (
    invoiceId: string,
    auctionName: string,
    onClickDownloadButton: boolean
  ) => {
    setIsUpdatedData(true);
    const Auth = new AuthService();
    if (onClickDownloadButton === true) {
      Auth.getRequestForDownload(
        `${isUserCurrencyCode()
          ? `${simpleAnnualPerforma}/${invoiceId}/download_performa`
          : `${internationalPerforma}${invoiceId}`
        }`,
        (status: any, response: any) => {
          if (status === 200) {
            if (response !== undefined) {
              const url = window.URL.createObjectURL(new Blob([response]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `${auctionName}.pdf`);
              document.body.appendChild(link);
              link.click();
            }
            setIsUpdatedData(false);
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setIsUpdatedData(false);
          } else {
            setAlertType("error");
            setShowMessage(response);
            setOpenToast(false);
            setIsUpdatedData(false);
          }
        }
      );
    }
  };

  const handleComponents = (categoryType: String) => {

    var joinedAuctions: any = localStorage.getItem("joinedAnnualAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);
    if (categoryType === "DIAMODS") {
      setShowJewelley(false);
      dispatch(setselectedDate({ date: "update_value" }));
      data = {
        filters: {
          and: [
            {
              match: "exact",
              name: "category",
              value: "Diamonds",
            },
          ],
        },

        page: {
          start: 0,
          count: 20,
          sort: {
            orders: [
              {
                property: "lastModifiedDate",
                direction: "DESC",
              },
            ],
          },
        },
      };
      if (joinedAuctions !== null) {
        joinedAuctions.filter((items: any) => {
          if (items.category === "Diamonds") {
            auctionId = items.perId;
          }
        });
      }
      getPerformaInvoiceList(auctionId, "Diamonds");
    } else {
      dispatch(resetSelectedDate());
      setShowJewelley(true);
      data = {
        filters: {
          and: [
            {
              match: "exact",
              name: "category",
              value: "Jewellery",
            },
          ],
        },
        page: {
          start: 0,
          count: 20,
          sort: {
            orders: [
              {
                property: "lastModifiedDate",
                direction: "DESC",
              },
            ],
          },
        },
      };
      if (joinedAuctions !== null) {
        joinedAuctions.filter((items: any) => {
          if (items.category === "Jewellery") {
            auctionId = items.perId;
          }
        });
      }
      getPerformaInvoiceList(auctionId, "Jewellery");

      //call api
    }
    // if (isUserCurrencyCode()) {
    //   getInvoiceList(data, auctionId);
    // } else {
    //   getusdInvoiceList(data, auctionId);
    // }
    getInvoiceList(data, auctionId);

    setIsShowTracking(false);
  };

  const getTrackingUIForInvoice = (auctionId: string) => {
    auctionIdForTrackingRecord = auctionId;
    setIsShowTracking(true);
  };

  const pushRequestInvoice = () => {
    Auth.postRequest(
      `${sendInvoiceRequest}?auctionId=${auctionId}`,
      "",
      (status: any, response: any) => {
        if (status === 200) {
          if (response !== undefined) {
            setAlertType("success");
            setShowMessage("Request Invoice email has been sent successfully.");
            setOpenToast(true);
            let isRequestEmail = true;
            dispatch(setIsRequest({ isRequestEmail }));
          } else {
            setAlertType("error");
            setShowMessage("opp!");
            setOpenToast(false);
            setIsLoading(false);
            setIsUpdatedData(false);
          }
        }
      }
    );
  };

  const allreadysent = () => {
    setAlertType("error");
    setShowMessage("Request Invoice mail already sent");
    setOpenToast(true);
    setTimeout(() => {
      setOpenToast(false);
    }, 3000);
  };

  const trackingButtonHandler = () => {
    setIsShowTracking(false);
  }

  return (
    <AppLayout t={t} {...props}>
      {apiTimeout === true ? (
        <ApiTimeout t={t} {...props} />
      ) : (
        <Grid>
          {isLoading === true ? (
            <div className="loader">
              <LoadingSpinner />
            </div>
          ) : (
            <Grid container={true} spacing={0}>
              <StyledLayoutGrid xs={12} item={true}>
                <SyledHeader xs={12} item>
                  {t("common:invoice:header")}
                </SyledHeader>
                {/* <Grid item={true} xs={12}>
                  <CategoryCarousal t={t} handleConponets={handleComponents} />
                </Grid> */}
                {invoice.length || performaInvoice.length > 0 ? (
                  <>
                    {isShowTracking === false ? (
                      <CoreDataofInvoiceProductAuction
                        t={t}
                        data={[...performaInvoice, ...invoice]}
                        selectedDates={onSelectDate}
                        totalElements={totalElements + totalElementsPerforma}
                        value={getUpdatedInvoiceList}
                        isShowPage={isShowTracking}
                        itemPerPage={itemPerPage}
                      >
                        <InvoiceListAuctionProduct
                          t={t}
                          shippingAddress={shippingAddress}
                          sendMessage={sendMessage}
                          apiTimeout={timeout}
                          downloadpdf={forDownloadInvoice}
                          downloadinternationalInvoice={internationalInvoice}
                          trakingUIInvoice={getTrackingUIForInvoice}
                          pushRequestInvoice={pushRequestInvoice}
                          downloadInternationalPerformaInvoice={
                            downloadInternationalPerformaInvoice
                          }
                          allreadysent={allreadysent}
                        />
                      </CoreDataofInvoiceProductAuction>
                    ) : (
                      <TrakingProcess
                        auctionIds={auctionIdForTrackingRecord}
                        isAnnualtype={true}
                        hideTrakingUi={trackingButtonHandler}
                      />
                    )}
                  </>
                ) : (
                  <StyledTextWrapper item={true} xs={12} lg={12} md={12}>
                    {t("common:invoice:noInvoice")}
                  </StyledTextWrapper>
                )}
              </StyledLayoutGrid>
              {isUpdatedData === true && (
                <div className="loader">
                  <LoadingSpinner />
                </div>
              )}
            </Grid>
          )}
        </Grid>
      )}
      {openToast === true && (
        <Alert showAlertMessage={showMessage} alertType={alertType} />
      )}
      {userBlock === true && (
        <StyledModal open={userBlock}>
          <BlockUserModal t={t} {...props} closeModal={closeModal} />
        </StyledModal>
      )}
    </AppLayout>
  );
};

export default ProductAuctionInvoice;
